/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import Tooltip from '@mui/material/Tooltip';

import styles from './TooltipIcon.module.scss';
import { FhirPageWidgetType } from '../../algorithm/types';
import icons from '../../public_editorcontent/pearl-icon-pack/icons';

type ButtonFhirIconProps = {
  className?: string;
  fhir?: FhirPageWidgetType;
  forceShowFhir?: boolean;
  pageId?: string;
  onFhirClick?: () => void;
};
/* Note that Tooltip sends a forwardRef to its child, and Icon doesn't like that.
   So we need a div for the Tooltip to attach the title to.
 */
export function ButtonFhirIcon({ className, fhir, pageId, onFhirClick, forceShowFhir }: ButtonFhirIconProps) {
  const isSet = fhir && !!fhir.predefinedWidgets.length;
  if (!isSet && !forceShowFhir) {
    return null;
  }

  return (
    <div className={className} data-testid="button-fhir-icon">
      <Tooltip title={forceShowFhir ? 'Set Contextualization' : ''} disableFocusListener>
        <div
          className={`${styles.buttonFhirIcon} ${isSet ? '' : styles.greyOut}`}
          dangerouslySetInnerHTML={{ __html: icons.fhir }}
          onClick={(e) => {
            onFhirClick?.();
            e.stopPropagation();
          }}
        />
      </Tooltip>
    </div>
  );
}
